import {titleTemplate, image, url} from './metaConfig'
export default function createMeta ({
  title,
  description,
  ogTitle,
  canonical,
  ogImage = image,
  ogDescription = null,
  twitterTitle = null,
  twitterDescription}) {
  return [
    {
      name: 'description',
      content: description,
      vmid: 'description'
    },
    // OpenGraph data
    {
      property: 'og:title',
      content: ogTitle || title || twitterTitle || 'Title Missing',
      template: '%s - ' + titleTemplate,
      vmid: 'og:title'
    },
    // og:url Should the the same as your canonical link.
    {
      property: 'og:url',
      content: canonical,
      vmid: 'og:url'
    },
    {
      property: 'og:image',
      content: url + ogImage,
      vmid: 'og:image'
    },
    {
      property: 'og:description',
      content: ogDescription || description || twitterDescription || 'Description Missing',
      vmid: 'og:description'
    },
    // STATIC OG
    {
      property: 'og:site_name',
      content: titleTemplate,
      vmid: 'og:site_name'
    },
    {
      property: 'og:type',
      content: 'website',
      vmid: 'og:type'
    },
    // Twitter card
    {
      name: 'twitter:site',
      content: canonical,
      vmid: 'twitter:site'
    },
    {
      name: 'twitter:title',
      content: twitterTitle || ogTitle || title || 'Title Missing',
      template: '%s - ' + titleTemplate,
      vmid: 'twitter:title'
    },
    {
      name: 'twitter:description',
      content: twitterDescription || ogDescription || description || 'Description Missing',
      vmid: 'twitter:description'
    },
    // STATIC  TWITTER
    {
      name: 'twitter:card',
      content: 'summary',
      vmid: 'twitter:card'
    },
    // Twitter handle, if you have one.
    // {name: 'twitter:creator', content: '@something'}
    // {name: 'twitter:image:src', content: 'https://www.my-site.com/my-special-image.jpg'},
    {
      itemprop: 'name',
      content: title || ogTitle || twitterTitle || 'Title Missing',
      template: '%s - ' + titleTemplate,
      vmid: 'schema-name'
    },
    {
      itemprop: 'description',
      content: description || ogDescription || twitterDescription || 'Description Missing',
      vmid: 'schema-description'
    },
    {
      itemprop: 'image',
      content: url + ogImage,
      vmid: 'schema-image'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/meta/createMeta.js